var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedDateRiskData && _vm.selectedDateRiskData.image)?_c('l-image-overlay',{attrs:{"bounds":_vm.imageInfo.bounds,"url":_vm.selectedDateRiskData.image.src,"opacity":_vm.imageOpacity}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }